import { useSelector } from 'react-redux';
import { ApplicationState } from '../rootStore';

export const useStateReducer = () =>
  useSelector((state: ApplicationState) => state.stateCountry);

